// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingSkeleton_wrap__H18lh","row":"LoadingSkeleton_row__YWsnT","cell":"LoadingSkeleton_cell__stwH5","pulse":"LoadingSkeleton_pulse__Jithc"};